import { computed, type Ref } from 'vue'
import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { useNotification } from '@/shared/ui'
import type { InventoryFilter } from './types.ts'

type LoadInventObjectData = {
  object_id: number
  points: number[][]
  zoom: number
  type_ids: number[]
  field_filters: InventoryFilter['fieldFilters']
}

/**
 * Функция загрузки списка инвентаризационных объектов
 */
export const useLoadInventObject = () => {
  const http = useHttp()
  const { trs } = useTranslate()
  const { addError } = useNotification()

  const mutation = useMutation({
    mutationFn: (data: LoadInventObjectData) => {
      return http.post(`/inventory/objects/${data.object_id}/polygon`, {
        points: data.points,
        zoom: data.zoom,
        type_ids: data.type_ids ?? [],
        field_filters: data.field_filters ?? [],
      })
    },
  })

  const send = async (data: LoadInventObjectData) => {
    await mutation.mutateAsync(data)
  }

  return {
    ...mutation,

    send,
  }
}

/**
 * Функция получения координат занимаемых инвентаризационными объектами
 */
export const useLoadInventSquareCoords = (objectId: Ref<number>, preSelectIds: Ref<string>) => {
  const http = useHttp()

  const url = computed(() => {
    const searchParams = new URLSearchParams({
      ids: preSelectIds.value,
    })
    return `/objects/${objectId.value}/square?${searchParams}`
  })

  return useQuery({
    queryKey: ['load_invent_square_coords', objectId, preSelectIds],
    queryFn: () => http.get(url.value),
    /** Запрос границ по объектам нужен только при наличии предвыбранных `ids`. */
    enabled: computed(() => !!preSelectIds.value),
    retry: false,
  })
}
